import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyRI5 from "components/pages/strategy/RI5";

interface Props {}

const StrategyRI5Page: NextPage<Props> = ({}) => {
  return <StrategyRI5 />;
};
export default StrategyRI5Page;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
